import * as PropTypes from "prop-types";

export const OptionGroup = PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string
});

export const OptionType = PropTypes.shape({
    key: PropTypes.string,
    value: PropTypes.any,
    label: PropTypes.string,
    group: PropTypes.oneOfType([OptionGroup, PropTypes.string]),
});

export const OptionTypeDisabled = PropTypes.shape({
    key: PropTypes.string,
    value: PropTypes.any,
    disabled: PropTypes.bool
});
